import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ContactUsService} from "../service/contact-us.service";
import {SharedConstants} from "../utilityClass/sharedConstants";
import {CONTACT_US_PHONE} from "../constants/contact-us.constants";
import {QrCopyMessageComponent} from "../qr-copy-message/qr-copy.component";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {MockupType} from "../qr-copy-message/mockup-type.enum";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from "@ngx-translate/core";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss', './contact-us-media.component.scss', '../layouts/filled-form-field/filled-form-field.component.scss']
})
export class ContactUsComponent {
  currentLang = '';

  protected contactForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private contactUsService: ContactUsService,
    private snackBar: MatSnackBar,
    public translate: TranslateService
  ) {
    this.contactForm = this.buildForm();
  }

  protected onSubmit(): void {
    if (this.contactForm.valid) {
      this.contactUsService.saveContactUs(this.contactForm.value).subscribe(res => {
        if (res){
          const message=this.successMessage()
          this.showSnackbar(message, SnackBarUtil.CLASSES.success);
          this.contactForm.reset();
          Object.keys(this.contactForm.controls).forEach(control => {
            this.contactForm.get(control)?.setErrors(null);
          });
        }

      })
    }
  }

  get fullName() {
    return this.contactForm.get('fullName')?.value;
  }

  get email() {
    return this.contactForm.get('email')?.value;
  }

  get phone() {
    return this.contactForm.get('phone')?.value;
  }

  get message() {
    return this.contactForm.get('message')?.value;
  }

  private buildForm(): FormGroup {
    return this.formBuilder.group({
      fullName: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phone: ['', []],
      message: ['', [Validators.required]],
    });
  }

  setValidators(fieldName: string) {
    this.contactForm.get(fieldName)?.updateValueAndValidity()
  }

  private showSnackbar(message: string, panelClassNames: string[]): void {
    this.snackBar.openFromComponent(QrCopyMessageComponent, {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: new MockupDataModel(message, MockupType.SUCCESS),
    });
  }

  private successMessage(): string {
    const messages: { [key: string]: string } = {
      en: 'Thanks for contacting us.',
      ru: 'Спасибо, что связались с нами.',
      am: 'Շնորհակալություն մեզ հետ կապ հաստատելու համար։'
    };
    return messages[this.translate.currentLang] || messages['en'];
  }

  protected readonly SharedConstants = SharedConstants;
  protected readonly CONTACT_US_PHONE = CONTACT_US_PHONE;
}
